import theme from 'theme';
import Routes from 'Routes';
import { chartjs } from 'helpers';
import validate from 'validate.js'; // ".js" faz parte do nome da pasta
import { APP_VERSION } from 'version';
import { Chart } from 'react-chartjs-2';
import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import validators from 'common/validators';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/styles';
import { PermissionProvider } from 'contexts/PermissionContext';


/* Estilos globais (sem export) */
import './assets/scss/index.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';

const browserHistory = createBrowserHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

/* Componente raiz da aplicação - monta o tema, as rotas e o controle de versão */
class App extends Component {
  isReloading = false;

  componentDidMount() {
    this.checkAppVersion();
    window.addEventListener('focus', this.checkAppVersion);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  };

  componentWillUnmount() {
    window.removeEventListener('focus', this.checkAppVersion);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  };

  handleVisibilityChange = () => {
    if (!document.hidden) {
      this.checkAppVersion();
    }
  };

  checkAppVersion = async () => {
    if (this.isReloading) {
      return;
    }

    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-store'
      });

      if (!response.ok) return;

      const data = await response.json();
      const serverVersion = String(data?.version || '').trim();

      if (serverVersion && serverVersion !== APP_VERSION) {
        const atualizar = window.confirm(
          'Existe uma nova versão disponível! Deseja atualizar agora?'
        );

        if (atualizar) {
          this.isReloading = true;

          window.removeEventListener('focus', this.checkAppVersion);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          window.location.reload();

          return;
        }
      }
    } catch (error) {
      console.error('Erro ao verificar a versão do app:', error);
    }
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <PermissionProvider>
          <Router history={browserHistory}>
            <Routes />
          </Router>
        </PermissionProvider>
      </ThemeProvider>
    );
  }
};

export default App;